'use client'

import _ from 'lodash'
import Image from 'next/image'
import { twMerge } from 'tailwind-merge'
import { TrashIcon } from '@heroicons/react/24/outline'

type CardHeaderProps = {
  alt?: string | null
  photoCount?: number | null
  photoUrl?: string | null
  className?: string
  isSold?: boolean
  isDeleted?: boolean
}

export function CardPhoto({ alt, className, photoCount, photoUrl, isSold, isDeleted }: CardHeaderProps) {
  return (
    <div className={twMerge(
      'border-b relative bg-zinc-100 dark:bg-transparent',
      className
    )}>
      {
        (photoCount || 0) > 0 &&
        <div className='absolute top-4 left-0 pl-2 pr-3 py-1.5 bg-zinc-700/50 text-white rounded-r-full flex items-center'>
          <span className='text-xs'>{photoCount}</span>
        </div>
      }
      {
        isDeleted &&
        <div className='absolute bottom-5 left-5 rounded-full p-3 bg-orange-800 ring-1 ring-white dark:ring-transparent' title='Deleted'>
          <TrashIcon className='size-6 text-white' />
        </div>
      }
      {
        isSold &&
        <div className='absolute bottom-0 left-0 right-0 px-4 py-2 bg-zinc-700/50 dark:bg-zinc-700/50 text-white font-bold tracking-wider text-center'>
          SOLD
        </div>
      }
      <Image
        width={480}
        height={480}
        src={photoUrl || '/img/noPhoto.svg'}
        alt={alt || 'Photo'}
        priority={true}
        fetchPriority='high'
        unoptimized={true} // disable it for better performance
        className={_.isEmpty(photoUrl) ? 'card-img-no' : 'card-img'}
        onError={e => e.currentTarget.src = '/img/noPhoto.svg'}
      />
    </div>
  )
}
